import { VFlow } from 'bold-ui'
import React from 'react'

import { AcompanhamentoPreNatalTabs } from './AcompanhamentoPreNatalTabs'
import { AntecedentesObstetricosCard } from './components/AntecedentesObstetricosCard'

interface AcompanhamentoPreNatalContentProps {
  prontuarioId: ID
  cidadaoId: ID
  dataReferencia: Instant
}

export function AcompanhamentoPreNatalContent(props: AcompanhamentoPreNatalContentProps) {
  const { prontuarioId, cidadaoId, dataReferencia } = props

  return (
    <VFlow>
      <AntecedentesObstetricosCard prontuarioId={prontuarioId} />
      <AcompanhamentoPreNatalTabs cidadaoId={cidadaoId} prontuarioId={prontuarioId} dataReferencia={dataReferencia} />
    </VFlow>
  )
}
